import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum AmaronRoles {
    "SystemAdmin" = "6b414507-5377-40fd-b7eb-10d947b19c83",
    "Admin" = "3bc49071-3e31-4ae2-af71-534326ee8d7a",
    "Manager" = "a80df536-a6d1-4feb-9ed5-08205213f106",
    "Agent" = "e786590f-8c84-4fe7-b86c-53166fb79d7e",
}

export const AMARON__USER_MANAGER__STATES__COLUMN_ID = "0dd7f870-0731-4262-a80d-f7efb6655635" as Uuid;

export const AMARON__USER_AGENT__PINCODES__COLUMN_ID = "6d23e233-8417-4d80-9e4a-56d265c0969a" as Uuid;

export const AMARON__USER_ADMIN__COUNTRIES__COLUMN_ID = "124adc17-0595-4015-b063-79f2c8375e3e" as Uuid;

// export const AMARON__USER_SYSTEM_ADMIN__STAFF_CODE__COLUMN_ID = "36bdc673-fab5-492a-963c-080a5a5e2a2c" as Uuid;

// export const AMARON__USER_ADMIN__STAFF_CODE__COLUMN_ID = "4042882b-01ba-4f7a-9c9d-73d85f226f09" as Uuid;

// export const AMARON__USER_MANAGER__STAFF_CODE__COLUMN_ID = "2a369917-20a6-4509-84be-593cbe74e4cd" as Uuid;

// export const AMARON__USER_AGENT__STAFF_CODE__COLUMN_ID = "bdc67f48-84c1-49ef-833a-48a9351d59ee" as Uuid;
